import { jsxs } from "react/jsx-runtime";
import Text from "@ingka/text";
const Label = (props) => {
  const {
    prefix = "",
    label = "Label",
    reqText,
    htmlFor,
    className,
    ...otherProps
  } = props;
  return /* @__PURE__ */ jsxs(
    Text,
    {
      prefix,
      textStyle: "LabelRegular.M",
      tagName: "label",
      htmlFor,
      className,
      colour: false,
      ...otherProps,
      children: [
        label,
        reqText && /* @__PURE__ */ jsxs("em", { className: `${prefix}required`, children: [
          " ",
          reqText
        ] })
      ]
    }
  );
};
var Label_default = Label;
export {
  Label_default as default
};
